module.exports = __webpack_public_path__ + "img/icon-time-warn.fa5db042.svg";